module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAAXNSR0IArs4c6QAAAT1JREFUOBGlVMFRwzAQXNl+MHxIB9ABmuEDvJwKkhIoIR2kBdwBHQAVxHzCKzNOB0kHefIgFrvC8tjY4zjDPXSn0+3e6U4jg0rsfXoTG8yMwST4hrRzOGw+8yxRkH1MbQysDMaBhWEiSRZpJfjlHLAwQTwBwbfBca72BH0g3jELftp7B7yHfVP3E5SYGoe3EMgKd5t1PifJNviC9k0MG2llOn6hkJ1cYCr9HeEgbUosEGElO0iHgNlmBFofUAUnDh/cpy7CM89b0n8FAfkm6kiDq7uH9JXgTrM7FTRAi9rmU+Hcf6tqOGX2V/AnaGj7b4LWFTQB3rMYylidLcNIWwSa9SmwtekkucSScTvFegKxqcO+02ZUBRwSrmuCI/AUO+TstCo4WYWAFKvFV1Cs84L/gWVH59HI/6DkfyCCHzXJRBlJDuWdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/ic_baitapcuatoi.png
// module id = 1264
// module chunks = 0